import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inner" }
const _hoisted_2 = { class: "status" }
const _hoisted_3 = { class: "dot" }
const _hoisted_4 = {
  key: 0,
  class: "icon static"
}
const _hoisted_5 = {
  key: 0,
  class: "icon animated"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "ellipsis" }
const _hoisted_9 = { class: "research-content" }
const _hoisted_10 = { class: "text fira-code-400" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Agent = _resolveComponent("Agent")
  const _component_AiInput = _resolveComponent("AiInput")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["research-item", {active: $options.active, 'fade-in': !!$options.input && !$props.completed}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              (!$options.active)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_Icon, { icon: "content" })
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              ($options.active)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_Icon, {
                      external: "",
                      icon: "animated/dot-loader"
                    })
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "line" }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Agent, {
            class: "agent",
            type: $options.agent || 'genrate',
            flat: ""
          }, null, 8 /* PROPS */, ["type"]),
          ($options.title)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))
            : _createCommentVNode("v-if", true),
          _createElementVNode("span", _hoisted_8, _toDisplayString($options.title), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", {
              class: _normalizeClass(["description", {typing: !$options.input}]),
              style: _normalizeStyle(`--length:${$options.description.length}`)
            }, _toDisplayString($options.description), 7 /* TEXT, CLASS, STYLE */)
          ]),
          ($options.input)
            ? (_openBlock(), _createBlock(_component_AiInput, {
                key: 0,
                input: $options.input,
                class: "ai-input",
                answer: $options.answer,
                disabled: !!$options.answer || !$props.last,
                onPrompt: _cache[0] || (_cache[0] = $event => (_ctx.$dispatch('answer-ai', $event)))
              }, null, 8 /* PROPS */, ["input", "answer", "disabled"]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ], 2 /* CLASS */))
}